import { LoadingSpinner } from '@kanda-libs/ks-design-library';

export interface FileDropProcessingProps {
  className: string;
}

const FileDropProcessing: React.FunctionComponent<FileDropProcessingProps> =
  function ({ className }) {
    return (
      <div className={className}>
        <div className="flex flex-col gap-y-6 w-full">
          <LoadingSpinner className="mx-auto" stroke="purple-400" />
          <p className="text-center text-neutral-700">
            Extracting information from PDF
          </p>
        </div>
      </div>
    );
  };

export default FileDropProcessing;
